import { ProcessingScreen } from '@components'

import { ReactElement, useCallback, useState } from 'react'
import { useNavigate } from 'react-router'

import { useOrganizationViewUrl } from '../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../utils/routing/reactRoute'
import { DemoInvoiceEditor } from './elements/DemoInvoiceEditor'

export const DemoInvoice = (): ReactElement => {
  const navigate = useNavigate()
  const [resetKey, setResetKey] = useState(0)
  const { url: invoicesListUrl } = useOrganizationViewUrl(reactRoute.organization.invoices.getMainRoute())

  const handleReset = useCallback(() => {
    setResetKey((key) => key + 1)
  }, [])

  const handleClose = useCallback(() => {
    if (invoicesListUrl) {
      navigate(invoicesListUrl)
    }
  }, [invoicesListUrl, navigate])

  if (!invoicesListUrl) {
    return <ProcessingScreen />
  }

  return (
    <DemoInvoiceEditor backButtonUrl={invoicesListUrl} key={resetKey} onClose={handleClose} onReset={handleReset} />
  )
}
